export default "__VITE_ASSET__BGVb4WqV__"